import { createRouter, createWebHistory } from "vue-router";
import appRoutes from "./routes";
import { getCookie } from "../../public/js/cookie";
import Home from "@/layout/page.vue";
import contentR from "@/components/contentR/rightConcent.vue";
import Login from "@/views/user/login.vue";
import Register from "@/views/user/register.vue";
import Plant from "@/views/plant/plant.vue";
import emptyCount from "@/views/evaluationLabel/empty.vue";
import bigDataRouter from "./bigData/data.js";
import bigDataDecorationRouter from "./bigDataDecoration/data.js";
import echartsMap from "@/components/echartsMap/index.vue";
import moreContent from "@/views/bigData/views/richTtext.vue";
let allRouter = [
  {
    name: "登录",
    path: "/login",
    component: Login,
  },
  {
    name: "底层地图",
    path: "/echartsMap",
    component: echartsMap,
  },
  {
    name: "更多配置内容",
    path: "/moreContent",
    component: moreContent,
  },
  {
    name: "其它登录",
    path: "/otherLogin",
    component: Login,
  },
  {
    name: "注册",
    path: "/register",
    component: Register,
  },
  {
    name: "基地面板一张图",
    path: "/plant",
    component: Plant,
  },
  {
    name: "首页",
    path: "/",
    component: Home,
    children: [
      {
        path: "",
        redirect: "/channelList",
      },
      {
        name: "",
        path: "",
        component: contentR,
        children: appRoutes,
      },
    ],
  },

  {
    path: "/customEdit",
    name: { list: ["数字店铺", "运营", "店铺装修", "移动端装修"] },
    component: () => import("@/views/customPage/edit/index.vue"),
  },
  {
    path: "/buyerCustomEdit",
    name: { list: ["数字店铺", "运营", "店铺装修", "移动端装修"] },
    component: () => import("@/views/customPageH5/edit/index.vue"),
  },
  {
    name: "产业工作台",
    path: "/channelList",
    component: () => import("@/views/user/channelList.vue"),
  },
  {
    name: "待办任务",
    path: "/task",
    component: () => import("@/views/pendingTask/top.vue"),
  },

  {
    name: "首页配置",
    path: "/shopCustom",
    component: () => import("@/views/shopDecoration/views/custom.vue"),
  },
  {
    name: "首页预览",
    path: "/shopPreview",
    component: () => import("@/views/shopDecoration/views/preview.vue"),
  },
  {
    name: "门户首页配置",
    path: "/doorCustom",
    component: () => import("@/views/shopDecoration/views/custom.vue"),
  },
  {
    name: "门户首页预览",
    path: "/doorPreviewH5",
    component: () => import("@/views/shopDecoration/views/previewH5.vue"),
  },
  {
    name: "门户首页移动端配置",
    path: "/doorCustomH5",
    component: () => import("@/views/shopDecoration/views/customH5.vue"),
  },
  {
    name: "门户首页移动端预览",
    path: "/doorPreview",
    component: () => import("@/views/shopDecoration/views/preview.vue"),
  },
  {
    name: "门户专题页配置",
    path: "/doorSpecialCustom",
    component: () => import("@/views/shopDecoration/views/custom.vue"),
  },
  {
    name: "门户专题页预览",
    path: "/doorSpecialPreview",
    component: () => import("@/views/shopDecoration/views/preview.vue"),
  },
  {
    name: "门户H5专题页配置",
    path: "/doorSpecialCustomH5",
    component: () => import("@/views/shopDecoration/views/customH5.vue"),
  },
  {
    name: "门户H5专题页预览",
    path: "/doorSpecialPreviewH5",
    component: () => import("@/views/shopDecoration/views/previewH5.vue"),
  },
  {
    name: "B2B专题页配置",
    path: "/shopSpecialCustom",
    component: () => import("@/views/shopDecoration/views/custom.vue"),
  },
  {
    name: "B2B专题页预览",
    path: "/shopSpecialPreview",
    component: () => import("@/views/shopDecoration/views/preview.vue"),
  },
  {
    path: "/emptyCount",
    name: "项目信息",
    component: emptyCount,
  },
  {
    path: "/bigDataDecoration",
    name: "大数据配置",
    component: () => import("@/views/bigDataDecoration/views/index.vue"),
  },
  {
    path: "/productDetails",
    name: "商品详情预览",
    component: () => import("@/views/digitalShop/productDetails.vue"),
  },
  {
    name: "店铺交易商城",
    path: "/shopmall",
    component: () => import("@/views/dealhome/layout/center.vue"),
    children: [
      {
        path: "",
        name: "店铺交易商城列表页",
        component: () => import("@/views/dealhome/goodsList.vue"),
      },
      {
        path: "shopIndex",
        name: "交易商城店铺",
        component: () => import("@/views/dealhome/shopIndex.vue"),
      },
      {
        path: "goodsDetails",
        name: "交易商城详情页",
        component: () => import("@/views/dealhome/goodsDetails.vue"),
      },
    ],
  },

  {
    name: "店铺交易商城列表",
    path: "/shopmallIndex",
    component: () => import("@/views/dealhome/layout/centerNoTop.vue"),
    children: [
      {
        path: "",
        name: "店铺交易商城列表",
        component: () => import("@/views/dealhome/goodsList.vue"),
      },
    ],
  },
  {
    name: "大数据设置",
    path: "/bigDataEdit",
    component: () => import("@/views/bigDataDecoration/project/test/edit.vue"),
  },
  {
    name: "数据采集H5",
    path: "/dataAcquisitionForm",
    component: () => import("@/views/dataAcquisition/form.vue"),
  },
  {
    name: "数据采集",
    path: "/dataManagementForm",
    component: () => import("@/views/dataAcquisition/dataManagementForm.vue"),
  },
  {
    name: "数据采集成功H5",
    path: "/dataAcquisitionSuccess",
    component: () => import("@/views/dataAcquisition/success.vue"),
  },
  {
    path: '/Pdfcomp',
    name: 'pdf预览',
    component: () => import('@/views/pdf/Pdfcomp.vue')
  },
  {
    path: '/workspace',
    name: '客服',
    component: () => import('@/views/agent/index')
  },
  // {path: '/chatIndex',name: '聊天',component: () => import('@/components/chat/chatIndex')}
];
// 兴隆山楂  xinglong
// 华南中药材  hnzyc
// 科右中旗  kyzq
// 彭阳县 pyx
let bigDataList = []
// 测试环境指定编译项目name
let projectName = 'kyzq'
if (process.argv.project == "developement" || process.argv.project == "test" ) {
  //当前为开发或者测试环境
  if (getCookie("proValue")) {
    // 已开发大数据页面路由引入
    let dataJson = bigDataRouter.find((e) => e.value == getCookie("proValue"));
    if (dataJson) {
      // 可以查询到当前项目标识的大数据配置
      allRouter = allRouter.concat(dataJson.list);
      bigDataList = dataJson.list
    } else {
      // 无法查询到当前项目标识的大数据配置，不做处理
    }

    // 配置大数据页面路由引入
    let newDataJson =  bigDataDecorationRouter.find((e) => e.value == getCookie("proValue"));
    if (newDataJson) {
      // 可以查询到当前项目标识的大数据配置
      allRouter = allRouter.concat(newDataJson.list);
    } else {
      // 无法查询到当前项目标识的大数据配置，不做处理
    }
  }else{
    // 已开发大数据页面路由引入
    let dataJson = bigDataRouter.find((e) => e.value == projectName);
    if (dataJson) {
      // 可以查询到当前项目标识的大数据配置
      allRouter = allRouter.concat(dataJson.list);
      bigDataList = dataJson.list[0].children
    } else {
      // 无法查询到当前项目标识的大数据配置，不做处理
    }
    
    // 配置大数据页面路由引入
    let newDataJson = bigDataRouter.find((e) => e.value == projectName);
    if (dataJson) {
      // 可以查询到当前项目标识的大数据配置
      allRouter = allRouter.concat(newDataJson.list);
    } else {
      // 无法查询到当前项目标识的大数据配置，不做处理
    }
  }
} else if (process.argv.project) {
  //当前为生产环境且有项目标识
  // 已开发大数据页面路由引入
  let dataJson = bigDataRouter.find((e) => e.value == process.argv.project);
  if (dataJson) {
    // 可以查询到当前项目标识的大数据配置
    allRouter = allRouter.concat(dataJson.list);
    bigDataList = dataJson.list[0].children|| dataJson.list
  } else {
    // 无法查询到当前项目标识的大数据配置，不做处理
  }

  // 配置大数据页面路由引入
  let newDataJson = bigDataRouter.find((e) => e.value == projectName);
  if (dataJson) {
    // 可以查询到当前项目标识的大数据配置
    allRouter = allRouter.concat(newDataJson.list);
  } else {
    // 无法查询到当前项目标识的大数据配置，不做处理
  }
} else {
  // 当前为生产环境且无项目标识，不做处理
}
// allRouter = allRouter.concat(bigDataDecorationRouter.find(e=>e.value=='test').list)
const router = createRouter({
  history: createWebHistory("/industry/"),
  routes: allRouter,
  scrollBehavior() {
    return { top: 0 };
  },
});
router.beforeEach((to, from, next) => {
  const user = getCookie("userInfoIndustry");
  const hrefList = ["/login", "/plant", "/ ","/moreContent", "/emptyCount", "/shopmall","/otherLogin","/brandYuny","/qualityEvaluation","/bigDataDecoration","/dataAcquisitionForm",'/dataAcquisitionSuccess','/Pdfcomp'].concat(bigDataList.map(e=>e.path));
  if (from.query.ltype && !to.query.ltype) {
    const newQuery = Object.assign({}, to.query, { ltype: from.query.ltype });
    // 使用新的查询对象来重置to.query
    to.query = newQuery;
    router.push({ path: to.path, query: newQuery });
    return;
  }
  if (to == from) return;
  if (!user) {
    let bmdIndex = hrefList.findIndex((e) => {
      return e == to.path || to.path.includes(e);
    })
    if (
      bmdIndex== -1
    ) {
      const j = bigDataList.find(e=>to.path.indexOf(e.path)>-1)
      if(j){
        // 如果来源为大数据页面则跳转大数据登录并携带重定向页面地址
        next({ replace: false, path: "/otherLogin" ,query: { redirect: to.path }});
        
      }else{
        next({ replace: false, path: "/login" });
      }
      
    } else {
      next();
    }
  } else {
    next();
  }
});

// createRouteGuard(router);
export default router;
